<div
	class="flex items-center bg-primary-100 dark:bg-standard bottom-0 justify-center left-0 fixed right-0 top-auto w-full h-14.5 z-mobile-nav print:hidden"
	(click)="clickInsideNav($event)"
>
	@if (appNavVisible()) {
		<div
			class="text-secondary-800 flex flex-col justify-center items-center h-full mx-3 w-17 text-[0.625rem]"
		>
			<mobile-app-nav
				[environment]="environment()"
				[apps]="apps()"
				[activeApp]="activeApp()"
				[navColor]="navColor()"
				[navTranslations]="navTranslations()"
				[open]="appNavOpen()"
				(toggled)="onAppNavToggled($event)"
				class="h-full"
			></mobile-app-nav>
		</div>
	}
	@for (item of items(); track item.name) {
		@if (isRouteItem(item)) {
			<a
				class="text-secondary-800 flex flex-col justify-center items-center h-full mx-3 w-17 text-[0.625rem]"
				[routerLink]="item.url"
				[class.bg-primary-200]="
					item === openedMenuPoint() ||
					(currentUrl() && item.url.includes(currentUrl()) && item.url !== '')
				"
				(click)="onMenuPointClick(item)"
			>
				<ng-container
					[ngTemplateOutlet]="itemContent"
					[ngTemplateOutletContext]="{ $implicit: item }"
				></ng-container>
			</a>
		} @else {
			<div
				class="text-secondary-800 flex flex-col justify-center items-center h-full mx-3 w-17 text-[0.625rem]"
				[class.bg-primary-200]="
					item === openedMenuPoint() ||
					item.active ||
					(currentUrl() && item.url.includes(currentUrl()) && item.url !== '')
				"
				(click)="onMenuPointClick(item)"
			>
				<ng-container
					[ngTemplateOutlet]="itemContent"
					[ngTemplateOutletContext]="{ $implicit: item }"
				></ng-container>
				@if (item.submenus) {
					<ui-mobile-nav-list
						[submenuItems]="item.submenus"
						[isOpen]="item === openedMenuPoint()"
						[currentUrl]="currentUrl()"
						(closeMenu)="closeMenu()"
						(click)="clickInsideNav($event)"
						[navColor]="navColor()"
						(callbackEvent)="callbackEvent.emit($event)"
					></ui-mobile-nav-list>
				}
			</div>
		}
	}
</div>

<ng-template #itemContent let-item>
	<ui-icon [type]="navColor()" [icon]="item.icon" size="l"> </ui-icon>
	<div
		class="mt-1"
		[class.text-secondary-800]="navColor() === 'dark'"
		[class.text-primary-700]="navColor() === 'primary'"
		[class.text-white]="navColor() === 'light'"
	>
		{{ item.name }}
	</div>
</ng-template>
